import { createFileRoute, Navigate } from '@tanstack/react-router';
import { WorkspaceLayout } from '@/features/workspace/WorkspaceLayout';
import { OverviewTab } from '@/features/workspace/tabs/OverviewTab';
import { CapitalStackTab } from '@/features/capital-stack/CapitalStackTab';
import { GapAnalysisTab } from '@/features/gap-analysis/GapAnalysisTab';
import { AuditTab } from '@/features/audit/AuditTab';
import { ImpactTab } from '@/features/impact/ImpactTab';
import { MemoTab } from '@/features/memo/MemoTab';
import { NarrativeTab } from '@/features/narrative/NarrativeTab';
import { DebtCapacityTab } from '@/features/debt-capacity/DebtCapacityTab';
import { FunderMatchTab } from '@/features/funder-matching/FunderMatchTab';
import { OutreachTab } from '@/features/outreach/OutreachTab';
import { ReadinessTab } from '@/features/readiness/ReadinessTab';
import { DocumentsTab } from '@/features/documents/DocumentsTab';

const TABS = ['overview', 'capital-stack', 'gap-analysis', 'pro-forma', 'debt-capacity', 'impact', 'funders', 'outreach', 'narrative', 'memo', 'readiness', 'documents'] as const;
type Tab = (typeof TABS)[number];

export const Route = createFileRoute('/projects/$projectId/workspace/$tab')({
  component: WorkspaceTabPage,
});

function WorkspaceTabPage() {
  const { projectId, tab } = Route.useParams();
  if (!TABS.includes(tab as Tab)) {
    return <Navigate to="/projects/$projectId/workspace/$tab" params={{ projectId, tab: 'overview' }} replace />;
  }
  return (
    <WorkspaceLayout>
      {tab === 'overview' && <OverviewTab />}
      {tab === 'capital-stack' && <CapitalStackTab />}
      {tab === 'gap-analysis' && <GapAnalysisTab />}
      {tab === 'pro-forma' && <AuditTab />}
      {tab === 'debt-capacity' && <DebtCapacityTab />}
      {tab === 'impact' && <ImpactTab />}
      {tab === 'funders' && <FunderMatchTab />}
      {tab === 'outreach' && <OutreachTab />}
      {tab === 'narrative' && <NarrativeTab />}
      {tab === 'memo' && <MemoTab />}
      {tab === 'readiness' && <ReadinessTab />}
      {tab === 'documents' && <DocumentsTab />}
    </WorkspaceLayout>
  );
}
